module.exports = __webpack_public_path__ + "img/cg_ruoyi_scan.5c07c587.jpg";